export default __webpack_public_path__ + "static/media/yoga.aa972e7c.jpg";